<template>
  <!--
    WHAT: Full-page wrapper for the "Entity Engagement" artifact. Entity
          Engagement is a pure config manager with NO DataAttributes / join graph
          at all, so it is a standalone manager, not a list→detail flow.
    WHERE: Rendered directly by MetricStudio.vue as the body for the Engagement
           artifact tab (registry `manager` / `fullManager: true`).
    CONTRACT: No props. No emitted events. Mounts and scrolls the wrapped manager;
              all state lives inside EntityEngagementConfigManager.
    NOTES: Wraps Admin/EntityEngagementConfigManager.vue — a pre-existing v1
           component reused VERBATIM by the redesign and shared with other parts
           of the app. Do NOT restyle EntityEngagementConfigManager without
           checking its other callers. Only the scroll chrome here is
           redesign-local.
  -->
  <div class="h-full overflow-y-auto ms2-scroll">
    <EntityEngagementConfigManager />
  </div>
</template>

<script>
import EntityEngagementConfigManager from '@/components/Admin/EntityEngagementConfigManager.vue';

export default {
  name: 'EngagementManager',
  components: { EntityEngagementConfigManager },
};
</script>

<style scoped>
.ms2-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
.ms2-scroll::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 10px; border: 3px solid transparent; background-clip: content-box; }
</style>
